/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from "vue-property-decorator";
import { getFinanceOrderListById } from '@/api/common'
import {formatDate} from "@/utils/timeFilter";

@Component({})
export default class GiveStudent extends Vue {
    // data
    tableData = []
    id = ''
    name = ''
    type = ''
    userName = ''
    source = ''
    createdAt = []

    created(){
      const obj = this.$route.query ;
      this.name = obj.name as string
      this.type = obj.type as string;
      this.userName = obj.userName as string;
      this.source = obj.source === '0' ? 'BD自开拓' : obj.source === '1' ? '市场自开拓' :  obj.source === '2' ? 'KA战略合作' :'高校业务部门'
      this.id = obj.id as string
      this.getTableData()
    }

    async getTableData() {
        const data = await getFinanceOrderListById({
                id: Number(this.id),
                createdAt: this.changeTime(this.createdAt)
            }
        ) as unknown as { financeOrderList: any[] }
        this.tableData = data.financeOrderList
    }

    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }
    //createdAt: this.changeTime(this.createdAt as Date[]), //提醒时间

    getSummaries(param: any) {
        const { columns, data } = param;
        let sums: any = [];
        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map((item: any) => Number(item[column.property]));
          if (!values.every((value: any) => isNaN(value))) {
            sums[index] = values.reduce((prev: any, curr: any) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev;
              }
            }, 0);
            sums[index]
          } else {
            sums[index] = '———';
          }
        });
        sums = sums.map(item => {
            if(typeof item === 'number') {
              return item.toLocaleString()
            } else {
              return item
            }
        });
        return sums;

    }
}
